/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Grid from "@mui/material/Grid";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { Link as RouterLink } from "react-router-dom";

function Footer() {
  return (
    <VuiBox
      component="footer"
      py={6}
      sx={({ breakpoints }) => ({
        maxWidth: "450px",
        [breakpoints.down("xl")]: {
          maxWidth: "400px",
        },
      })}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <VuiTypography
            variant="button"
            sx={{ textAlign: "center", fontWeight: "400 !important" }}
            color="text"
          >
            @ 2026, Made with ❤️&nbsp;&nbsp;&nbsp; by {"EL4 Development"}
          </VuiTypography>
          <VuiBox mt={1} display="flex" justifyContent="center" gap={2} flexWrap="wrap">
            <RouterLink to="/legal/privacy-policy" style={{ color: "#8bc6ff", textDecoration: "underline" }}>
              Privacy Policy
            </RouterLink>
            <RouterLink to="/legal/terms-and-conditions" style={{ color: "#8bc6ff", textDecoration: "underline" }}>
              Terms & Conditions
            </RouterLink>
            <RouterLink to="/legal/security-contact" style={{ color: "#8bc6ff", textDecoration: "underline" }}>
              Security Contact
            </RouterLink>
          </VuiBox>
        </Grid>
      </Grid>
    </VuiBox>
  );
}

export default Footer;

